import React, { useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useNavigate } from "react-router-dom";
import placeholderSrc from "../placeholder"
import "./styles.scss";
import photo from "../../assets/photos/UNM_HS-Wellness_Art-Walk-3_WEB.jpg";
function SectionTwo({ path, placeholderSrc, parent }) {

  console.log(placeholderSrc.height)
  return (
    <div>
      <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-1">
        <div className="tw-spacer tw-h-[6rem]"></div>
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-[40%_60%] tw-relative">
          <div></div>
          <div className="tw-relative">
            <div className="sectionNumber tw-absolute tw-font-extrabold xl:tw-text-[11.0rem] xl:tw-leading-[11.0rem]">
              2
            </div>
          </div>
        </div>
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-[40%_60%]">
          <div className="tw-order-2 lg:tw-order-[1]">
           
            <div>
              <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-[10%_70%_20%] ">
                <div></div>
                <div className="tw-px-4 lg:tw-px-0 tw-grid tw-grid-cols-[90%_10%] lg:tw-grid-cols-1">
                  <div className="tw-mt-8 lg:tw-mt-0 tw-l-border-[1px] tw-border-l-[1px] tw-border-white tw-pl-3 ">
                    <p className="tw-font-bold tw-italic tw-mb-4 tw-mb-0 w-text-2xl tw-text-2xl tw-w-1/2 tw-text-2xl tw-w-1/2">
                    Thistle
                    </p>
                    <p>
                      The creator of this piece, William Goodman immigrated to
                      the United States in 1959. A teaching opportunity in
                      Albuquerque then brought him to New Mexico, where he has
                      produced much public and privately owned art. This 1977
                      commission was dedicated to the HSC Staff. Like the
                      thistle it is named for, this piece elicits the beauty of
                      the plant's thorny but beautiful bloom and bristled stem.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-order-1 lg:tw-order-[2]">
            <LazyLoadImage
              alt="Thistle"
              placeholderSrc={placeholderSrc}
              src={photo} // use normal <img> attributes as props
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export default SectionTwo;
